import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

type FetchCompany = {
  companyId: string;
  enabled?: boolean;
  onError?: (error: HttpException | unknown) => void;
};

export const useCardSetupSecret = ({ companyId, enabled = true, onError }: FetchCompany) => {
  const queryClient = useQueryClient();

  const { data, isLoading, refetch } = useAppQuery({
    queryKey: [QueryKey.GET_CARD_SETUP_INTENT_SECRET, companyId],
    queryFn: () =>
      ApiService.get<{ clientSecret: string }>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'card-setup-secret'],
      }),
    enabled: !!companyId && enabled,
    onError,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_CARD_SETUP_INTENT_SECRET] });
  }, [queryClient]);

  return {
    isLoading,
    invalidateQuery,
    refetch,
    setupIntentSecret: data?.clientSecret || '',
  };
};
